import { AxiosResponse, AxiosError } from 'axios';

import {
    WORKSHEET_LOAD_FAILED,
    WORKSHEET_LOAD_REQUESTED,
    WORKSHEET_LOAD_SUCCEEDED,
    WORKSHEET_SET
} from './constants';

// Types
import {
    RequestLoadWorksheetAction,
    SuccededLoadWorksheetAction,
    FailedLoadWorksheetAction,
    Worksheet,
    SetWorksheetAction,
    WorksheetRequestPayload
} from './types';

export function requestLoadWorksheet(
    payload: WorksheetRequestPayload
): RequestLoadWorksheetAction {
    return {
        type: WORKSHEET_LOAD_REQUESTED,
        payload
    };
}

export function succeededLoadWorksheet(
    response: AxiosResponse
): SuccededLoadWorksheetAction {
    return {
        type: WORKSHEET_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadWorksheet(
    error: AxiosError
): FailedLoadWorksheetAction {
    return {
        type: WORKSHEET_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function setWorksheet(payload: Worksheet): SetWorksheetAction {
    return {
        type: WORKSHEET_SET,
        payload
    };
}
